
/* styles */
require("!!vue-style-loader!css-loader?minimize!../node_modules/vue-loader/lib/style-rewriter?id=data-v-28aa17c9&scoped=true!../node_modules/vue-loader/lib/selector?type=styles&index=0!./AccordionMenu.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./AccordionMenu.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-28aa17c9!../node_modules/vue-loader/lib/selector?type=template&index=0!./AccordionMenu.vue"),
  /* scopeId */
  "data-v-28aa17c9",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/AccordionMenu.vue
// module id = 73
// module chunks = 0